export default function CommentContent({ content, profilesMap }) {
    if (!content) return null

    const parts = content.split(/(@\([0-9a-f-]{36}\))/)

    return (
        <div className="whitespace-pre-wrap">
            {parts.map((part, i) => {
                const match = part.match(/^@\(([0-9a-f-]{36})\)$/)

                if (match) {
                    const profile = profilesMap[match[1]]

                    if (!profile) {
                        return (
                            <span
                                key={i}
                                className="text-gray-400 italic"
                            >
                                @Utilisateur supprimé
                            </span>
                        )
                    }

                    if (profile.disabled) {
                        return (
                            <span key={i} className="text-gray-400">
                                @{profile.name}
                            </span>
                        )
                    }

                    return (
                        <span
                            key={i}
                            className="text-blue-600 font-medium"
                        >
                            @{profile.name}
                        </span>
                    )
                }

                return <span key={i}>{part}</span>
            })}
        </div>
    )
}
